import { render, staticRenderFns } from "./footerMenu.vue?vue&type=template&id=b7ebd94a&scoped=true&"
import script from "./footerMenu.vue?vue&type=script&lang=js&"
export * from "./footerMenu.vue?vue&type=script&lang=js&"
import style0 from "./footerMenu.vue?vue&type=style&index=0&id=b7ebd94a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ebd94a",
  null
  
)

export default component.exports